var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedalerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:sack"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26 14.625C32.5 17.875 34.125 29.25 34.125 29.25C34.125 29.25 35.75 35.75 26 35.75H13C3.25 35.75 4.875 29.25 4.875 29.25C4.875 29.25 6.5 17.875 13 14.625M22.75 6.5L19.5 3.25L16.25 6.5L9.75 3.25L13 11.375H26L29.25 3.25L22.75 6.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedalerts);
export default __webpack_public_path__ + "static/media/feed alerts.c2b2ecbd37507d40d9e52ddb73e46d26.svg";
export { ForwardRef as ReactComponent };